import React from 'react';
import classNames from 'classnames';
import { Phrases } from '../../utilities/constants/phrases';
import styles from './SubscriptionStatus.module.scss';
import TooltipFreePlan from '../Tooltip/TooltipFreePlan/TooltipFreePlan';
import TooltipPremiumPlan from '../Tooltip/TooltipPremiumPlan/TooltipPremiumPlan';

interface Props {
  isPremium: boolean;
  className?: string;
}

const SubscriptionStatus: React.FC<Props> = ({ isPremium, className }) => {
  const Tooltip = isPremium ? TooltipPremiumPlan : TooltipFreePlan;

  return (
    <Tooltip>
      <span
        className={classNames(
          'flex-ai-c flex-jc-c fw-bold ff-primary tt-uppercase whs-nowrap',
          styles.status,
          className,
          {
            [styles.premium]: isPremium,
            [styles.free]: !isPremium,
          }
        )}>
        {isPremium
          ? Phrases.SUBSCRIPTION_STATUS_PREMIUM
          : Phrases.SUBSCRIPTION_STATUS_FREE}
      </span>
    </Tooltip>
  );
};

export default SubscriptionStatus;
